import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import baseHelper from '../../../helpers/BaseHelper';
import appConst from '../../../config/const';
import Spinner from '../../../components/Spinner';
import storeActions from '../../../redux/futures/store/actions';
import ItemAddon from './ItemAddon';
import EditAddon from './EditAddon';
import ConfirmModal from '../../../components/ConfirmModal';
import * as types from '../../../redux/futures/store/types';

class ListAddon extends React.Component {
    static propTypes = {
        currentUser: PropTypes.object,
        onCancel: PropTypes.func
    }

    constructor(props) {
        super(props);
        this.state = {
            resource_limits: [],
            selectedResource: null
        };
    }

    componentDidMount() {
        this.props.getAddonsList({ ladi_uid: this.props.currentUser._id });
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.resource_limits) {
            this.setState({
                resource_limits: nextProps.resource_limits
            });
        }
        // Check if previous action was completed
        if (nextProps.action == types.ADD_RESOURCE_LIMIT
            || nextProps.action == types.UPDATE_RESOURCE_LIMIT
            || nextProps.action == types.DELETE_RESOURCE_LIMIT
        ) {
            // Check which action was completed

            // Check if action was successful
            if (nextProps.status) {
                window.LadiUI.toastr('success', '', nextProps.message);

                // Close modals based on action type
                if (nextProps.action === types.ADD_RESOURCE_LIMIT) {
                    window.LadiUI.closeModalById('modal-item-addon');
                } else if (nextProps.action === types.UPDATE_RESOURCE_LIMIT) {
                    window.LadiUI.closeModalById('modal-edit-addon');
                } else if (nextProps.action === types.DELETE_RESOURCE_LIMIT) {
                    window.LadiUI.closeModalById('confirm-delete-addon');
                }

                // Recall getAddonsList after successful action
                this.props.getAddonsList({ ladi_uid: this.props.currentUser._id });
            } else {
                // Show error message if action failed
                window.LadiUI.toastr('error', '', nextProps.message);
            }
        }
    }

    edit = (resource) => {
        this.setState({ selectedResource: resource });
    }

    delete = (resource) => {
        this.setState({ selectedResource: resource });
    }

    render() {
        const { currentUser } = this.props;
        const { resource_limits, selectedResource } = this.state;
        const isLoadingDelete = this.props.loading && (this.props.waitting == types.DELETE_RESOURCE_LIMIT);

        return (
            <div id="modal-list-addon" className="ladiui-modal fade" tabIndex={-1} data-dismiss="modal-list-addon" style={{ zIndex: '21' }}>
                <div className="ladiui-modal-content">
                    <div className="ladiui-modal-header">
                        <button type="button" className="ladiui-close-modal" data-dismiss="modal-list-addon">
                            <i className="ladi-icon icon-e-remove" data-dismiss="modal-list-addon" />
                        </button>
                        <h3>Thông tin các addon</h3>
                        <button
                            className="ladiui button primary icon-c-add open-modal"
                            modal="modal-item-addon"
                            style={{ marginLeft: '10px' }}
                            onClick={() => this.props.getResourceLimitConfig()}
                        >
                            Thêm giới hạn tài nguyên
                        </button>
                    </div>
                    <div className="ladiui-modal-body">
                        <div className="order-box" style={{ margin: '15px' }}>
                            <div className="ladiui-row" style={{ height: '50px' }}>
                                <div className="col-50">
                                    <strong>Tên gói: </strong>
                                    {currentUser.pkg_name || '--'}
                                </div>
                                <div className="col-50">
                                    <strong>Ngày hết hạn: </strong>
                                    {currentUser.pkg_exp ? baseHelper.formatStrToDate(currentUser.pkg_exp) : '--'}
                                </div>
                            </div>
                            <div className="ladiui-row" style={{ height: '50px' }}>
                                <div className="col-50">
                                    <strong>Email: </strong>
                                    {currentUser.email}
                                </div>
                                <div className="col-50">
                                    <strong>Họ tên: </strong>
                                    {currentUser.fullname}
                                </div>
                            </div>
                        </div>

                        <table className="ladiui table">
                            <thead>
                                <tr>
                                    <th className="text-left">Ứng dụng</th>
                                    <th className="text-left">Loại tài nguyên</th>
                                    <th className="text-left">Giá trị giới hạn</th>
                                    <th className="text-left">Ngày hết hạn</th>
                                    <th className="text-left">Thao tác</th>
                                </tr>
                            </thead>
                            <tbody>
                                {resource_limits.map((resource, index) => (
                                    <tr key={index}>
                                        <td>{resource.app_code}</td>
                                        <td>{resource.resource_type}</td>
                                        <td>{resource.limit_value}</td>
                                        <td>{baseHelper.formatStrToDate(resource.exp_date)}</td>
                                        <td>
                                            <ul className="ladiui-navbar -horizontal row-actions">
                                                <li className="ladiui-dropdown">
                                                    <a><i className="ladi-icon icon-dots"></i></a>
                                                    <ul>
                                                        <li><a onClick={() => this.edit(resource)} className="ladiui open-modal" modal="modal-edit-addon" >Sửa</a></li>
                                                        <li><a onClick={() => this.delete(resource)} className="ladiui open-modal" modal="confirm-delete-addon" >Xóa</a></li>
                                                    </ul>
                                                </li>
                                            </ul>
                                        </td>
                                    </tr>
                                ))}
                                {resource_limits.length === 0 && (
                                    <tr className="text-center">
                                        <td colSpan="5">Không có giới hạn tài nguyên</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                        {this.props.loading && <Spinner />}
                    </div>
                </div>
                <ItemAddon
                    ref={this.formRef}
                    currentUser={currentUser}
                    onCancel={this.onCancel}
                />
                <EditAddon
                    currentUser={currentUser}
                    selectedResource={selectedResource}
                />
                <ConfirmModal
                    id="confirm-delete-addon"
                    title="Xóa giới hạn tài nguyên"
                    content="Hành động này rất quan trọng, bạn có chắc chắn thực hiện?"
                    cancelText="Huỷ bỏ"
                    okText="Đồng ý"
                    onOk={() => this.props.deleteResourceLimit({ id: selectedResource._id })}
                    isLoading={isLoadingDelete}
                />
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    resource_limits: state.store.resource_limits,
    loading: state.store.loading,
    waitting: state.store.waitting,
    status: state.store.status,
    message: state.store.message,
    action: state.store.action
});

const mapDispatchToProps = (dispatch) => ({
    getAddonsList: (data) => dispatch(storeActions.getAddonsList(data)),
    getResourceLimitConfig: () => dispatch(storeActions.getResourceLimitConfig()),
    deleteResourceLimit: (data) => dispatch(storeActions.deleteResourceLimit(data))
});

export default connect(mapStateToProps, mapDispatchToProps)(ListAddon); 